<template>
  <div>
    <nav-title>
      <div slot="rightTool">
        <el-button type="primary" icon="icon-plus" @click="openFormDialog">
          添加元素
        </el-button>
        <el-button type="primary" @click="jumpTagsList">元素标签管理</el-button>
      </div>
    </nav-title>
    <div class="layout-main">
      <div class="filter">
        <el-select
          v-model="tagId"
          placeholder="元素标签"
          size="small"
          @change="fetchData({ tagIds: tagId })"
        >
          <el-option
            label="全部"
            :value="0"
          ></el-option>
          <el-option
            :label="item.name"
            :value="`${item.id}`"
            v-for="item in tags"
            :key="item.id"
          ></el-option>
        </el-select>
      </div>
      <list-row :gutter="22" :width="90" style="flex:1">
        <list-col v-for="item in list" :key="item.id">
          <div class="element-item">
            <img :src="item.image_url" :alt="item.name" />
            <i class="el-icon-delete" @click="handleDelete(item)"> </i>
          </div>
        </list-col>
      </list-row>
      <el-pagination
        class="cl-pagination"
        background
        layout="prev, pager, next , sizes"
        @size-change="handleSizeChange"
        @current-change="handleChangePage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        :total="total"
        v-if="total"
        :current-page.sync="$store.state[namespace].page"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="添加元素"
      :visible.sync="dialogVisible"
      width="600"
      :before-close="handleClose"
    >
      <el-form :rules="rules" :model="form" ref="ruleForm">
        <el-form-item label="元素标签" prop="tagIds">
          <el-select v-model="form.tagIds">
            <el-option
              v-for="item in tags"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传元素" prop="image_url">
          <image-upload
            :auto-upload="true"
            @success="onUploadSuccess"
            :url="form.image_url"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave">
          确 定
        </el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import NavTitle from 'components/NavTitle';
import Row from 'components/List/Row';
import Col from 'components/List/Col';
import ListMixins from '../../mixins/list';
import MultiSelecter from 'components/MultiSelecter';
import ImageUpload from 'components/upload/ImageUpload';
import warning from 'assets/images/warning.png';

export default {
  name: 'ElementList',
  mixins: [ListMixins],
  data() {
    return {
      dialogVisible: false,
      namespace: 'element',
      form: {
        image_url: ''
      },
      rules: {
        image_url: [{ required: true, message: '元素图片不能为空' }],
        tagIds: [{ required: true, message: '请选择所属标签' }]
      },
      tagId: ''
    };
  },
  computed: {
    tags() {
      return this.$store.state.elementTag.list || [];
    }
  },
  mounted() {
    this.fetchTags();
  },
  methods: {
    jumpTagsList() {
      this.$router.push({ path: '/tags/list' });
    },
    onUploadSuccess(url) {
      this.form.image_url = url;
      this.$refs.ruleForm.validateField('image_url');
    },
    openFormDialog() {
      this.dialogVisible = true;
      this.fetchTags();
    },
    fetchTags() {
      this.$store.dispatch('elementTag/fetch', {
        pageSize: 1000,
        type: 3
      });
    },
    handleSave() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$store
            .dispatch(this.namespace + '/save', this.form)
            .then(data => {
              this.$message.success('新增成功');
              this.dialogVisible = false;
              this.fetchData();
              this.$nextTick(() => {
                this.$refs['ruleForm'].resetFields();
                this.tagId = '';
              });
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleDelete(data) {
      this.$confirm(
        `
					<img src=${warning} alt="" width="59" st/>
					<p style="
						font-size: 16px;
						font-weight: bold;
						padding-bottom: 19px;
						display: block;
						color: rgba(0, 0, 0, 0.65);">
						确定删除该元素吗？
					</p>
				`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          center: true
        }
      ).then(() => {
        this.$store
          .dispatch(this.namespace + '/delete', {
            id: data.id
          })
          .then(data => {
            this.$message.success('删除成功');
            this.fetchData();
          });
      });
    },
    handleClose() {
      this.dialogVisible = false;
    }
  },
  components: {
    'nav-title': NavTitle,
    'list-row': Row,
    'list-col': Col,
    'multi-selecter': MultiSelecter,
    'image-upload': ImageUpload
  }
};
</script>
<style lang="scss" scoped>
.layout-main {
  min-height: calc(100% - 60px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.filter {
  margin-bottom: 20px;
}
.element-item {
  border-radius: 4px;
  border: 1px solid #e9edf0;
  background-color: #fff;
  padding: 8px;
  width: 100%;
  height: 90px;
  position: relative;
  margin-bottom: 20px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    display: none;
  }
  .el-icon-delete {
    position: absolute;
    left: 50%;
    top: 50%;
    color: #fff;
    transform: translate(-50%, -50%);
    display: none;
    cursor: pointer;
  }
  &:hover {
    &::before,
    .el-icon-delete {
      display: block;
    }
  }
}
.cl-pagination {
  padding-bottom: 0;
}
</style>
